import { createContext } from 'react';
import { BootConfig } from 'types/BootConfig';
import bootConfig from 'utils/bootConfig';

const BootConfigContext = createContext<BootConfig>(bootConfig);

export default BootConfigContext;
